import { MenuItem } from '@mui/material'

export const getSelectOptions = (opt, index) => {
    return opt.map((item) => (
        <MenuItem key={item.label + '-' + index} value={item.value}>
            {item.label}
        </MenuItem>
    ))
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}
